import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { motion } from "framer-motion";

export default function FAQSection({ items, label = "FAQs", title = "Frequently asked questions", testId = "faq-section" }) {
  return (
    <section data-testid={testId} className="py-24 md:py-32 border-t border-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="label-eyebrow mb-4">{label}</div>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-display text-4xl md:text-5xl font-semibold tracking-tighter text-[#F3E8E0] leading-[0.95]"
            >
              {title}
            </motion.h2>
            <p className="mt-6 text-[#A3A3A3] max-w-sm">
              Still curious? Reach us at{" "}
              <a href="mailto:contact@incer.in" className="text-[#FF4A00] hover:underline">
                contact@incer.in
              </a>{" "}
              for anything specific.
            </p>
          </div>
          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full" data-testid={`${testId}-accordion`}>
              {items.map((item, idx) => (
                <AccordionItem
                  key={idx}
                  value={`item-${idx}`}
                  className="border-b border-[#1a1a1a]"
                  data-testid={`faq-item-${idx}`}
                >
                  <AccordionTrigger className="py-6 text-left text-lg md:text-xl font-display font-medium text-[#F3E8E0] hover:no-underline [&>svg]:text-[#FF4A00] [&>svg]:w-5 [&>svg]:h-5">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base text-[#A3A3A3] leading-relaxed max-w-2xl">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
